/* ------------------------------------------ GFFRAME - Chris 03.08.2016 ----------------------------------------- */
import { GET } from '@/app/api/index';
import * as Sentry from '@sentry/vue';
import config from '@/app/editor/config';
import { addBlockedScript } from '@/app/utils/helpers.ts';
import prependScriptToHead from '@/app/utils/prependScriptToHead';
import store from '@/app/store/store';
import { app } from '@/store';
import { getGlobalVariable } from '@/app/editor/config/globalVariable';
import { checkKeyValid } from '@/app/utils/checkRoleApply';

(function (jQuery) {
  jQuery.gfFrame = function (element, options) {
    const defaults = {};
    this.settings = {};

    const $element = jQuery(element);

    const _this = this;

    // let publicPath = config.domain() + '/editor';

    // if (import.meta.env.VITE_APP_MODE === 'production') {
    //   publicPath = 'https://' + import.meta.env.VITE_APP_CF_URL + '/' + import.meta.env.VITE_APP_E_PATH;
    // }

    const publicPath = import.meta.env.VITE_APP_CF_URL;
    const _appStyle = [];
    _appStyle.push(`${publicPath}/libs/css/gryffEditor.css`);
    _appStyle.push(`${publicPath}/files/vendor.css`);
    _appStyle.push(`${publicPath}/libs/css/gfv1animate.min.css`);

    let $gfLeftSideBar = jQuery('#gfLeftSideBar');
    /* iframe */
    const $gfFrame = getGlobalVariable('gfFrame');
    const $gfFrameLoader = getGlobalVariable('gfFrameLoader');
    let $gryffEditor = getGlobalVariable('gryffEditor');
    let $gryffBody = getGlobalVariable('gryffBody');
    let timeoutIframeLoad = null;

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      this.setFrameUrl();
      return false;
    };

    this.setFrameUrl = async function (pUrl, pType) {
      app.$store.commit('page/SET_DEFAULT_FRAME_LOADING', false); // OFF loading all screen
      _this.showTips();
      app.$store.commit('page/SET_LOADING_CONTENT_EDITOR', true); // ON loading content editor
      console.time('IFRAME-LOAD');
      let interval = -1;
      if (window.__initTemplateRunning) {
        await new Promise((resolve) => {
          clearInterval(interval);
          interval = setInterval(() => {
            if (!window.__initTemplateRunning) {
              clearInterval(interval);
              resolve(true);
            }
          }, 10);
        });
      }
      console.timeEnd('IFRAME-LOAD');
      const content = window.___templateInfo;
      $element.attr('srcdoc', `${content}`);
      $element.on('load', this.onIframeLoaded);
      this.timeoutIframeOnLoad(); // await 15s
    };

    this.timeoutIframeOnLoad = function () {
      if (timeoutIframeLoad) clearTimeout(timeoutIframeLoad);

      timeoutIframeLoad = setTimeout(function () {
        const $isEditingBody = $element.contents().find('.gryffeditor').first();
        if ($isEditingBody) {
          // _this.onIframeLoaded(); // stop process & send to sentry
          _this.detectSourceLoadPending();
        } else {
          _this.timeoutIframeOnLoad();
        }
      }, 15 * 1000);
    };

    this.onIframeLoaded = function () {
      if (timeoutIframeLoad) clearTimeout(timeoutIframeLoad);

      //get window of gfFrame
      app.$store.commit('page/SET_LOADING_CONTENT_EDITOR', false);
      // ADD SCRIPT
      window._iframeWindow = document.getElementById('gfFrame').contentWindow;

      if (window._iframeWindow && window._iframeWindow.GEMSTORE) {
        const blockedScripts = window._iframeWindow.GEMSTORE.getState('blockedScripts');
        if (blockedScripts && blockedScripts.length) {
          for (let i = 0; i < blockedScripts.length; i++) {
            addBlockedScript(blockedScripts[i]);
          }
        }
      }
      $element.show();
      // Register shortcuts
      jQuery(document).gfShortcut();
      $element.contents().gfShortcut();

      // find 1st .gryffeditor in case there are more than one gryffeditor by accident
      $gryffEditor = $element.contents().find('.gryffeditor').first();
      // add class editing to know that we are in editing mode
      $gryffEditor.addClass('editing');

      $gryffBody = $gryffEditor.closest('body');
      $gryffBody.addClass('gempage-editing');

      /**
       * cập nhật lại page id (id lưu trong DB của GempPages nếu đang lỗi)
       * Vì nếu template-page template-article khi load vào page đang trả về id = 0 gây lỗi một số nơi (pageSettings)
       * */
      const pageInfo = store.getValue('__page');
      if (pageInfo && pageInfo.page && pageInfo.page.id == 0) {
        //tìm content
        const pageId = $gryffBody.find('#gem-data-page-id').text();
        if (pageId) {
          pageInfo.page.id = parseInt(pageId);
          store.setValue('__page', pageInfo);
        }
      }

      if (
        !$gryffEditor.length ||
        ($gryffEditor.children().length && $gryffEditor.find('.module-wrap, .element-wrap, .gf_row').length === 0)
      ) {
        if ($gryffEditor.find('.text-edit').length > 0) {
          var html = '<div class="element-wrap" data-label="Text Block">';
          html += '<div class="elm text-edit" contenteditable="true">';
          html += $gryffEditor.find('.text-edit').html();
          html += '</div>';
          html += '</div>';
        } else if (app.$store.getters['app/pageType'] != 'template-page') {
          var html = '<div class="element-wrap" data-label="Text Block">';
          html += '<div class="elm text-edit" contenteditable="true">';
          html += $gryffEditor.html();
          html += '</div>';
          html += '</div>';
        }
        $gryffEditor.html(html);
      }

      // remove custom style and custome script file
      $element.contents().find('link.gf_page_style').remove();
      $element.contents().find('script.gf_pages_script').remove();

      // Append app Style
      let _linksStyle = '';
      for (let i = 0; i < _appStyle.length; i++) {
        _linksStyle += '<link href="' + _appStyle[i] + '" rel="stylesheet" type="text/css" />';
      }
      // to avoid tool without css issue
      _linksStyle += '<style type="text/css">.gf-tool { display: none;} </style>';

      $element.contents().find('head').append(_linksStyle);

      $element
        .contents()
        .find('script.gf_libs')
        .each(function () {
          window._pageLibs.push(jQuery(this).attr('src'));
        });

      $element
        .contents()
        .find('link.gf_libs')
        .each(function () {
          window._pageLibs.push(jQuery(this).attr('href'));
        });
      $gryffEditor.gryffEditor({
        shopDomain: _this.getShopDomain(),
      });
      $gfLeftSideBar?.data('gfleftsidebar')?.refreshGlobalVariable();
      const iframe = $element.contents();
      jQuery(iframe).scroll(function () {
        window._isScrolling = true;
        if (window._toolTimeout) {
          clearTimeout(window._toolTimeout);
          window._toolTimeout = null;
        }
        clearTimeout($.data(this, 'scrollCheck'));
        $.data(
          this,
          'scrollCheck',
          setTimeout(function () {
            window._isScrolling = false;
          }, 250),
        );
      });
    };

    this.detectSourceLoadPending = function () {
      const $sources = $element.contents().find('script[src]');
      const sources = [];
      $sources.each(function () {
        const src = $(this).attr('src');
        if (src && !sources.includes(src)) {
          sources.push(src);
        }
      });
      if (sources.length) {
        Sentry.withScope((scope) => {
          scope.setLevel('error');
          scope.setExtra('data', JSON.stringify(sources));
          Sentry.captureMessage(`This src cannot be loaded after 15 seconds - ${window.___gemShopInfo?.shopifyDomain}`);
        });
      }
    };

    this.getPageId = function () {
      return $element.attr('data-id') || '';
    };

    this.getPageTitle = function () {
      return $element.attr('data-title') || '';
    };

    this.getPageHandle = function () {
      return $element.attr('data-handle') || '';
    };

    this.getPageMeta = function () {
      return $element.attr('data-meta') || '';
    };

    // LAZYLOADING2019
    this.getPageLazyload = function () {
      return $element.attr('data-lazyload') == 'true' ? true : false;
    };
    this.setPageLazyload = function (lazyload) {
      $element.attr('data-lazyload', lazyload + '');
    };

    this.getPageUrl = function () {
      return $element.attr('data-page') || '';
    };

    this.getPageType = function () {
      return $element.attr('data-type') || '';
    };

    this.getShopDomain = function () {
      return $element.attr('data-shop') || '';
    };

    this.getShopPlan = function () {
      return $element.attr('data-plan') || '';
    };

    this.isPublishPage = function () {
      if ($element.attr('data-published') == 'true') {
        return true;
      } else {
        return false;
      }
    };

    this.setPublishPage = function (value) {
      $element.attr('data-published', value);
    };

    this.isDefaultPage = function () {
      if ($element.attr('data-default') == '1') {
        return true;
      } else {
        return false;
      }
    };

    this.setDefaultPage = function (value) {
      $element.attr('data-default', value);
      return false;
    };

    this.showLoading = function (messages) {
      function setStatus(i, timer) {
        setTimeout(function () {
          $gfFrameLoader.find('.status').html(messages[i]);
        }, timer);
      }
      $gfFrameLoader.show();
      $gfFrameLoader.addClass('show');

      if (messages != undefined) {
        const time = 1500;
        for (let i = 0; i < messages.length; i++) {
          const timer = i * time;
          setStatus(i, timer);
        }
      }
      return false;
    };

    this.showTips = function () {
      $gfFrameLoader.show();
      $gfFrameLoader.addClass('show');

      return false;
    };

    this.hideLoading = function () {
      getGlobalVariable('gfContainer').removeClass('gfContainer-loading');
      $gfFrameLoader.fadeOut(400, function () {
        $gfFrameLoader.hide();
        $gfFrameLoader.removeClass('show');
      });
    };
    this.init();
  };

  jQuery.fn.gfFrame = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gfframe')) {
        const plugin = new jQuery.gfFrame(this, options);
        jQuery(this).data('gfframe', plugin);
      }
    });
  };
})(jQuery);
